<template>
  <Pagination
    :current-page="1"
    component-name="StandardArticle"
    data-attribute-name="payload"
    :data-list="articlesByTag"
    :entries-per-page="3"
    :key-function="(entry, index) => index"
  />
</template>

<script>
import Vue from 'vue';
import Pagination from '../shared/Pagination.vue';
import StandardArticle from './StandardArticle.vue';

Vue.component('StandardArticle', StandardArticle);

export default {
  name: 'ArticlesByTag',
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    tag: null,
  }),
  computed: {
    articlesByTag() {
      const data = [];
      this.list.forEach(article => {
        if (
          ((article.attributes.tags || []).includes(this.tag) && article.attributes.language === this.$i18n.locale) ||
          (!article.attributes.language && this.$i18n.locale === 'de')
        ) {
          data.push(article);
        }
      });
      return data.sort((entry1, entry2) => Date.parse(entry2.attributes.date) - Date.parse(entry1.attributes.date));
    },
  },
  components: {
    Pagination,
  },
  created() {
    this.tag = this.$route.params.tag;
  },
  watch: {
    $route(to, from) {
      this.tag = to.params.tag;
    },
  },
};
</script>
